import React, {useState} from "react";
import TextField from "../../elements/TextField/TextField";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";
import {callAPI} from "../../utils/utils";
import {useSnackbar} from "notistack";
import OutlinedSelect from "../../elements/OutlinedSelect/OutlinedSelect";
import ModalDialog from "../../elements/ModalDialog/ModalDialog";

const PaymentMethodUpdater = (props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [ type, setType ] = useState("none");
  const [ paypal, setPaypal ] = useState("");
  const [ iban, setIban] = useState("");
  const [ accountOwner, setAccountOwner] = useState("");
  const [ working, setWorking ] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setWorking(true);
    const data = {
      type: type,
      paypal: paypal,
      account_owner: accountOwner,
      iban: iban
    };
    callAPI("payment/update", "POST", data).then(() => {
      enqueueSnackbar(t("PaymentBox.MethodEditor.SaveSuccess"), {variant:'success'});
      setWorking(false);
      props.onClose();
    }).catch(() => {
      enqueueSnackbar(t("PaymentBox.MethodEditor.SaveError"), {variant:'error'});
      setWorking(false);
    });
  }

  return (
    <ModalDialog headline={"PaymentBox.MethodEditor.Headline"} info={"PaymentBox.MethodEditor.Info"} width={600}>
      <form onSubmit={handleSubmit}>
        <div>
          <OutlinedSelect
            id={'type'}
            label={t("PaymentBox.MethodEditor.Type")}
            value={type}
            required
            width={560}
            onChange={(value) => {setType(value);}}
            items={[
              {value: 'none', name: t("PaymentBox.MethodEditor.TypeNone")},
              {value: 'paypal', name: t("PaymentBox.MethodEditor.TypePaypal")},
              {value: 'iban', name: t("PaymentBox.MethodEditor.TypeIban")}
            ]}
          />
        </div>
        {type === 'paypal' && <div>
          <TextField
            id="paypal"
            onChange={(e) => {setPaypal(e.target.value);}}
            label={t("PaymentBox.MethodEditor.Paypal")}
            value={paypal}
          />
        </div>}
        {type === 'iban' && <div>
          <TextField
            id="accountOwner"
            onChange={(e) => {setAccountOwner(e.target.value);}}
            label={t("PaymentBox.MethodEditor.AccountOwner")}
            value={accountOwner}
          />
        </div>}
        {type === 'iban' && <div>
          <TextField
            id="iban"
            onChange={(e) => {setIban(e.target.value);}}
            label={t("PaymentBox.MethodEditor.Iban")}
            value={iban}
          />
        </div>}
        <div style={{textAlign: 'left', marginLeft: 0}}>
          <Button
            type="button"
            size="large"
            variant="contained"
            color="primary"
            working={working}
            className="submit"
            onClick={props.onClose}
          >
            {t("PaymentBox.MethodEditor.Abort")}
          </Button>
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            working={working}
            className="submit"
          >
            {t("PaymentBox.MethodEditor.Submit")}
          </Button>
        </div>

      </form>
    </ModalDialog>
  );
}

export default PaymentMethodUpdater;